const highRiskTypes = [
  "0_full_0_tgod_signed",
  "386",
  "aepl",
  "aru",
  "asf",
  "asx",
  "atm",
  "aut",
  "bat",
  "bhx",
  "bin",
  "bkd",
  "blf",
  "bll",
  "bmw",
  "boo",
  "bps",
  "bqf",
  "buk",
  "bup",
  "bxz",
  "capxml",
  "cc",
  "ce0",
  "ceo",
  "cfxxe",
  "chm",
  "cih",
  "cla",
  "class",
  "cmd",
  "com",
  "crypt1",
  "ctbl",
  "cxq",
  "cyw",
  "dbd",
  "delf",
  "dev",
  "dlb",
  "dli",
  "dll",
  "dllx",
  "docm",
  "dom",
  "drv ",
  "dx",
  "dxz",
  "dyv",
  "dyz",
  "exe",
  "exe_renamed",
  "exe1",
  "ezt",
  "fag",
  "fjl",
  "fnr",
  "fuj",
  "gadget",
  "gzquar",
  "hc",
  "hlp",
  "hlw",
  "hsq",
  "hta",
  "htm",
  "html",
  "hts",
  "inf",
  "iva",
  "iws",
  "jar",
  "js",
  "jse",
  "kcd",
  "let",
  "lik",
  "lkh",
  "lnk",
  "lok",
  "lpaq5",
  "mcq",
  "mfu",
  "mjg",
  "mjz",
  "msi",
  "msp",
  "nls",
  "oar",
  "ocx",
  "osa",
  "ozd",
  "pcx",
  "pgm",
  "php3",
  "pid",
  "pif",
  "plc",
  "pr",
  "ps1",
  "ps1xml",
  "ps2",
  "ps2xml",
  "psc1",
  "psc2",
  "py",
  "qit",
  "qrn",
  "rhk",
  "rna",
  "rsc_tmp",
  "s7p",
  "scf",
  "scr",
  "scr",
  "sfx",
  "shs",
  "ska",
  "smm",
  "smtmp",
  "sop",
  "spam",
  "ssy",
  "swf",
  "tko",
  "tmp",
  "tps",
  "tsa",
  "tti",
  "txs",
  "upa",
  "uzy",
  "vb",
  "vb",
  "vbe",
  "vbs",
  "vbx",
  "vexe",
  "vxd",
  "vzr",
  "wlpginstall",
  "wmf",
  "ws",
  "wsc",
  "wsh",
  "xdu",
  "xir",
  "xlm",
  "xlv",
  "xnt",
  "xnxx",
  "xtbl",
  "zix",
  "zvz"
];

export default highRiskTypes;
